export const getTagCloudWidgetData = (state) => state.tagCloudWidget;
export const getIsTagCloudWidgetAdapterEnabled = (state) => getTagCloudWidgetData(state).enabled;
